import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    lazyGetServerOptionsForFeature,
    OwsOptionsFeatureType,
    SxSOptions,
} from 'owa-outlook-service-options';

export default async function saveSxSOptions(options: Partial<SxSOptions>) {
    const getServerOptionsForFeature = await lazyGetServerOptionsForFeature.import();
    const serverOptions =
        (getServerOptionsForFeature &&
            (await getServerOptionsForFeature<SxSOptions>(OwsOptionsFeatureType.SxS))) ||
        getOptionsForFeature<SxSOptions>(OwsOptionsFeatureType.SxS);
    const mergedOptions: SxSOptions = {
        ...serverOptions,
        ...options,
    };
    lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.SxS, mergedOptions);
}

export async function saveHideReadingPaneOption(hideReadingPane: boolean) {
    await saveSxSOptions({ hideReadingPane });
}
